// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  findingId: __t.u64().primaryKey().name("finding_id"),
  workspaceId: __t.option(__t.u64()).name("workspace_id"),
  orgId: __t.option(__t.u64()).name("org_id"),
  scope: __t.string(),
  claim: __t.string(),
  taskTagsJson: __t.string().name("task_tags_json"),
  evidenceRefsJson: __t.string().name("evidence_refs_json"),
  aggregateCount: __t.u32().name("aggregate_count"),
  confidence: __t.f32(),
  visibility: __t.string(),
  createdByAgentId: __t.option(__t.u64()).name("created_by_agent_id"),
  createdAt: __t.i64().name("created_at"),
  revisitAt: __t.option(__t.i64()).name("revisit_at"),
  supersededBy: __t.option(__t.u64()).name("superseded_by"),
});
